// extracted by mini-css-extract-plugin
export var fadeInOut = "_4j-3";
export var icon = "_4j-4";
export var savedIndicator = "_4j-2";
export var savingIndicator = "_4j-0";
export var spin = "_4j-1";